import { GOOGLE_MAPS_API_KEY } from "../utils/constants";

import { Libraries, useJsApiLoader } from "@react-google-maps/api";
import { useEffect } from "react";
import usePlacesAutocomplete, {
  getDetails,
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";

const libraries: Libraries = ["places"];

type SelectedGoogleLocation = {
  address: string;
  city: string;
  state: string;
  country: string;
  lat: number | string;
  lng: number | string;
  destinationGooglePlaceID: string;
};

export const useGoogleMaps = () => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY!,
    libraries: libraries,
    id: "google-api-script",
  });

  const {
    setValue: setAutoCompleteValue,
    suggestions: { status, data, loading },
    init,
  } = usePlacesAutocomplete({
    initOnMount: false,
    requestOptions: {
      // region: "ng",
      // componentRestrictions: { country: "ng" },
      // locationBias: new google.maps.LatLng(
      //   9.082,
      //   8.6753,
      // ), // Nigeria center
    },
  });

  useEffect(() => {
    if (isLoaded && !loadError) {
      init();
    }
    if (loadError) {
      console.log("Ewooo ooooo");
    }
    // eslint-disable-next-line
  }, [isLoaded, loadError]);

  const handleSelect = async (
    address: string,
    placeId: string,
    getMoreInfo: boolean = true,
    onSelect?: (loc?: SelectedGoogleLocation) => void,
  ) => {
    try {
      if (getMoreInfo) {
        let city_ = "";
        let state_ = "";
        let country_ = "";

        const results = await getGeocode({ address });
        const { lat, lng } = await getLatLng(results[0]);

        results[0].address_components.forEach((component) => {
          if (
            component.types.includes("locality") ||
            component.types.includes("administrative_area_level_2")
          ) {
            city_ = component.long_name;
          }

          if (component.types.includes("administrative_area_level_1")) {
            state_ = component.long_name;
          }

          if (component.types.includes("country")) {
            country_ = component.long_name;
          }
        });

        const placeData = {
          address: address,
          city: city_,
          state: state_,
          country: country_,
          lat: lat,
          lng: lng,
          destinationGooglePlaceID: placeId,
        };

        if (onSelect) {
          onSelect(placeData);
        }
      } else {
        if (onSelect) {
          onSelect(undefined);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    isLoaded: isLoaded && !loadError,
    loading,
    status,
    data,
    handleSelect,
    setAutoCompleteValue,
    getDetails,
  };
};
